export default __webpack_public_path__ + "static/media/StressedPicture.71f38781.png";